import { render, staticRenderFns } from "./ExtraFieldsInfo.vue?vue&type=template&id=5d827492&scoped=true"
import script from "./ExtraFieldsInfo.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsInfo.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldsInfo.vue?vue&type=style&index=0&id=5d827492&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d827492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d827492')) {
      api.createRecord('5d827492', component.options)
    } else {
      api.reload('5d827492', component.options)
    }
    module.hot.accept("./ExtraFieldsInfo.vue?vue&type=template&id=5d827492&scoped=true", function () {
      api.rerender('5d827492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtraFieldsInfo.vue"
export default component.exports